<template>
    <div class="editable" v-dropdown="editing">
        <a class="editable-click" href="#" @click.prevent>
            <template v-if="!userRoles.length">Keine</template>
            <template v-for="role in userRoles">{{ role }}<br></template>
        </a>

        <div class="editable-input">
            <be-form-group>
                <template v-for="role in checkboxOptions">
                    <label class="custom-control custom-checkbox" :key="role.value">
                        <input
                            ref="options"
                            class="custom-control-input"
                            type="checkbox"
                            name="roles"
                            :value="role.value"
                            :disabled="role.disabled"
                            :checked="role.checked"
                            @change="updateSelection"
                        >
                        <span class="custom-control-label">
                            <template>{{ role.label }}</template>
                        </span>
                    </label>
                </template>
            </be-form-group>

            <submit-button h-space type="button" icon="check" @click="save"/>
            <submit-button type="button" color="secondary" icon="close" @click="cancel"/>
        </div>
    </div>
</template>

<script>
    import User from '../../../../models/User';

    export default {
        props: {
            user: {
                type: User,
                required: true,
            },
            isCurrent: Boolean,
        },

        data: () => ({
            editing: null,
            selection: [],
        }),

        computed: {
            rolesMap: () => User.RolesMap,

            userRoles: vm => vm.user.roles.filter(role => !!User.RolesMap[role]).map(
                role => User.RolesMap[role],
            ),

            checkboxOptions: (vm) => {
                if (vm.isCurrent) {
                    return [{
                        value: 'ROLE_COACH',
                        label: User.RolesMap.ROLE_COACH,
                        checked: vm.selection.includes('ROLE_COACH'),
                    }];
                }

                return Object.keys(User.RolesMap).map(
                    role => ({
                        value: role,
                        label: User.RolesMap[role],
                        disabled: role !== 'ROLE_ADMIN' && role !== 'ROLE_COACH' && vm.selection.includes('ROLE_ADMIN'),
                        checked: vm.selectedRoles.includes(role) || (vm.selection.includes('ROLE_ADMIN') && role !== 'ROLE_COACH'),
                    }),
                );
            },

            selectedRoles: (vm) => {
                if (vm.isCurrent || vm.selection.includes('ROLE_ADMIN')) {
                    const roles = ['ROLE_ADMIN'];

                    if (vm.selection.includes('ROLE_COACH')) {
                        roles.push('ROLE_COACH');
                    }

                    return roles;
                }

                return vm.selection;
            },
        },

        methods: {
            async save() {
                this.editing = false;

                try {
                    await this.user.sync({ roles: this.selectedRoles });
                    this.user.roles = this.selectedRoles;
                    this.selection = this.selectedRoles;
                } catch (err) {
                    this.$store.dispatch('notifications/add', {
                        color: 'danger',
                        title: 'Fehler beim Speichern',
                        description: `Die Berechtigungen für ${this.user.firstname} ${this.user.lastname} konnten nicht gespeichert werden.`,
                    });
                }

                this.editing = null;
            },

            cancel() {
                this.selection = this.user.roles;
                this.editing = false;

                this.$nextTick(() => {
                    this.editing = null;
                });
            },

            updateSelection() {
                const inputs = this.$refs.options;
                const values = [];
                let i;

                for (i = 0; i < inputs.length; i += 1) {
                    if (inputs[i].checked) {
                        values.push(inputs[i].value);
                    }
                }

                this.selection = values;
            },
        },

        mounted() {
            this.selection = this.user.roles;
        },
    };
</script>
